<!-- TODO(ET) - addAdjustmentDialogComponent and AddAdjustmentComponent should probably be consolidated at this point. AddAdjustmentComponent assumes it will only ever exist inside of a dialog. -->
<add-adjustment [itemId]="itemId" [transaction]="transaction">
</add-adjustment>
